import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './styles/index.css'

export default class LayerWithProgress extends Component {
    render() {
        return (
            <div className="layer-progress-container">
                <div
                    className="spark-progress spark-progress--sm progressindicator-component spark-progress--horizontal"
                    role="progressbar">
                    <progress></progress>
                    <span className="spark-progress__text" role="status">{this.props.loadingText}</span>
                    <span className="spark-progress__meter"></span>
                </div>
            </div>
        )
    }
}

LayerWithProgress.propTypes = {
    loadingText: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/shared/components/LayerWithProgress/index.js